import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';
import GeniLoader from '../../components/GeniLoader';
import { useOptionsLocale } from '../../context/OptionsLanguageContext';

export const OptionsSyncButton = ({ onSync, syncing, testId, compact = false, className = '' }) => {
  const { t } = useOptionsLocale();

  if (compact) {
    return (
      <Button
        onClick={onSync}
        disabled={syncing}
        size="sm"
        className={`gap-2 rounded-full bg-white px-4 text-black hover:bg-white/90 disabled:bg-white/70 ${className}`}
        data-testid={testId}
      >
        <RefreshCw size={14} className={syncing ? 'animate-spin' : ''} />
        <span data-testid={`${testId}-label`}>{syncing ? t('common.syncingNow') : t('common.syncNow')}</span>
      </Button>
    );
  }

  return (
    <Button
      onClick={onSync}
      disabled={syncing}
      variant={syncing ? 'ghost' : 'default'}
      className={syncing ? `gap-2 bg-transparent px-0 py-0 text-white/78 shadow-none hover:bg-transparent hover:text-white disabled:opacity-100 disabled:bg-transparent disabled:text-white/78 ${className}` : className}
      data-testid={testId}
    >
      {syncing ? (
        <>
          <GeniLoader size="sm" inline className="py-0.5" iconClassName="bg-transparent" />
          <span data-testid={`${testId}-label`}>{t('common.syncingNow')}</span>
        </>
      ) : t('common.syncNow')}
    </Button>
  );
};

export default OptionsSyncButton;